// Reducer para Json General

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: { participantes: [] },
}

export const metadata = createSlice({
    name: 'jsonMetadata',
    initialState,
    reducers: {
        setAgregarParticipante: (state, action) => {
            let lenArr = state.value.participantes.length;
            state.value.participantes = [...state.value.participantes, { id: (lenArr + 1), nombre: action.payload.nombre, tipo: action.payload.tipo }]
        },
        setNombreProyecto: (state, action) => {
            state.value = { ...state.value, nombreProyecto: action.payload.projectName }
        },
        setVotingSys: (state, action) => {
            state.value = { ...state.value, votingSystem: action.payload.votingSystem }
        },
        setMultiplicadorSys: (state, action) => {
            state.value = { ...state.value, multiplicador: action.payload.multiplicador }
        },
        addIssuesSys: (state, action) => {
            state.value = { ...state.value, issues: action.payload.issues }
        }

    },
})

// Action creators are generated for each case reducer function
export const { setAgregarParticipante, setNombreProyecto, setVotingSys, setMultiplicadorSys, addIssuesSys} = metadata.actions

export default metadata.reducer